module.exports = __webpack_public_path__ + "img/back.6407e066.png";